import * as React from 'react';
/**
 * @internal
 */
export const PresenceGroupChildContext = React.createContext(undefined);